import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/app/(product-detail)/telephones-mobiles/[slug]/error.tsx");
